import { render, staticRenderFns } from "./TargetSKU.vue?vue&type=template&id=82a0e470&scoped=true&"
import script from "./TargetSKU.vue?vue&type=script&lang=js&"
export * from "./TargetSKU.vue?vue&type=script&lang=js&"
import style0 from "./TargetSKU.vue?vue&type=style&index=0&id=82a0e470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a0e470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82a0e470')) {
      api.createRecord('82a0e470', component.options)
    } else {
      api.reload('82a0e470', component.options)
    }
    module.hot.accept("./TargetSKU.vue?vue&type=template&id=82a0e470&scoped=true&", function () {
      api.rerender('82a0e470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/LeaderBoard/components/TargetSKU.vue"
export default component.exports